<template>
  <div class="filter-group">
    <input :id="fg.label" class="toggle toggle-checkbox" type="checkbox" checked>
    <label :for="fg.label" class="lbl-toggle">{{ $filters.capitalize(fg.label) }}</label>
    <div class="collapsible-content">
    <ul class="filter-options">
      <li :class="{  'term-selected' : isSelected(t.key) }" v-for="t in fg.buckets.slice(0,10)">
        <a type="button" href="" class="term-label filter-term" @click.prevent="toggleFilterAction(fg.field, t.key)">
          {{ $filters.capitalize(t.key) }}
        <span class="term-count">({{ t.doc_count }})</span>
        <span v-if="isSelected(t.key)" class="text-small">
          <svg class="svg-icon i-checkmark">
            <use xlink:href="#i-checkmark"></use>
          </svg>
          <svg class="svg-icon i-close">
            <use xlink:href="#i-close"></use>
          </svg>
        </span>
        </a>
      </li>
      <li class="term-label show-more" v-if="fg.more > 0 || fg.buckets.length > 10">
        <a href="" type="button" @click.prevent="moreAction">Show More...</a>
      </li>
    </ul>
    </div>
    <facets-modal v-if="showMore"
                  @close="showMore=!showMore"
                  :fg="fg"
    ></facets-modal>
  </div>
</template>
<script setup>
  import { getCurrentInstance, ref, reactive, toRaw } from 'vue'
  import facetsModal from './_facets-modal.vue'
  import { useFacets } from '../composables/useFacets';


  const components = {
    "facets-modal": facetsModal
  }
  
  const props = defineProps({
    field : String,
    fg : Object
  })

  const instance = getCurrentInstance()
  const $eventBus = instance.appContext.config.globalProperties.$eventBus

  const {
    toggleFilterAction,
    isActive,
    defaultSize
  } = useFacets()

  const showMore = ref(false)

  const isSelected = (term) => {
    return isActive(term, props.fg.field)
  }

  const moreAction = () => {
    showMore.value = true
  }
</script>